/* ============================================================================
   IL | Facet groups
   Prestige's open_filters_by_default is all or nothing: every group open, or every
   group shut. The useful middle is a few groups open and the long ones closed, so
   the drawer opens short but still shows the filters people actually reach for.

   Which groups open is a theme setting, matched on the group's own label so it keeps
   working if Search & Discovery reorders them.

   Degrades safely: without JavaScript every group stays as Prestige rendered it.
   See reference/THEME-EDITS.md.
   ========================================================================= */
(() => {
  /* Hide filter values that are genuinely noise. Empty by default, and it should stay that
     way for anything real. Well Versed Homes is the house label, not an unbranded default,
     so it belongs in the Brand list even though it sits on two thirds of the catalogue. */
  const hidden = (document.documentElement.dataset.ilHideFacetValues || '')
    .split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);

  const hideValues = (root) => {
    if (!hidden.length) return;
    root.querySelectorAll('label').forEach((l) => {
      const text = (l.textContent || '').replace(/\d+$/, '').trim().toLowerCase();
      if (!text || !hidden.includes(text)) return;
      const row = l.closest('.checkbox-control, li, .v-stack > *') || l.parentElement;
      if (row) row.hidden = true;
    });
  };

  const raw = document.documentElement.dataset.ilOpenFacets || '';
  const wanted = raw.split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
  if (!wanted.length && !hidden.length) return;

  const apply = (root) => {
    root.querySelectorAll('details').forEach((d) => {
      const label = (d.querySelector('summary')?.textContent || '')
        .trim().split('\n')[0].toLowerCase();
      if (!label) return;
      /* Only ever opens, and only once per group, so a group the shopper closed stays closed
         until the filters re-render it. IL EDIT 2026-10-25: aria-expanded is set as well as
         open. Prestige's accordion reads aria-expanded to decide whether a click opens or
         closes, so with open alone the group read as collapsed to screen readers and took
         two clicks to close. */
      if (d.dataset.ilFacetOpened || !wanted.some((w) => label.startsWith(w))) return;
      d.dataset.ilFacetOpened = 'true';
      if (!d.open) d.open = true;
      d.setAttribute('aria-expanded', 'true');
    });
  };

  const run = () => document.querySelectorAll('.facets, facets-drawer, #facets-drawer')
    .forEach((root) => { apply(root); hideValues(root); });

  run();
  /* Facet updates re-render the section, so re-apply when new markup arrives. */
  document.addEventListener('facet:update', () => setTimeout(run, 350));
  /* One pass per frame, however many nodes arrive in it. */
  let queued = false;
  new MutationObserver((records) => {
    if (queued || !records.some((r) => r.addedNodes.length)) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; run(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
